import { Alert, AlertDescription, AlertIcon, Box, useColorModeValue } from '@chakra-ui/react'

export const Disclaimer = ({ disclaimerText }: { disclaimerText: string }) => {
  // Use colors with sufficient contrast - warning status colors are accessible
  const textColor = useColorModeValue('flame.800', 'flame.200')

  return (
    <Alert status="warning" variant="outline" alignItems="start" borderRadius="md" py={0} px={0}>
      <AlertIcon />
      <Box>
        <AlertDescription
          fontSize="sm"
          display="flex"
          alignItems="start"
          textAlign="left"
          color={textColor}
        >
          {disclaimerText}
        </AlertDescription>
      </Box>
    </Alert>
  )
}
